module.exports = __webpack_public_path__ + "static/media/broken-image.616d5cb1.svg";